import { render, staticRenderFns } from "./BeltSection.vue?vue&type=template&id=fe518cba&scoped=true&"
import script from "./BeltSection.vue?vue&type=script&lang=js&"
export * from "./BeltSection.vue?vue&type=script&lang=js&"
import style0 from "./BeltSection.vue?vue&type=style&index=0&id=fe518cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe518cba",
  null
  
)

/* custom blocks */
import block0 from "./BeltSection.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports